import { render, staticRenderFns } from "./ReviewNotificationComponent.vue?vue&type=template&id=5ff3b631&"
import script from "./ReviewNotificationComponent.vue?vue&type=script&lang=ts&"
export * from "./ReviewNotificationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports